import { useTextes } from '@common/config';
import { CampagneStatut, OrganismeStatutType } from '@common/services';
import React from 'react';
import { useAppConfig } from '../../../hooks/use-app-config.hook';
import { useInscriptionState } from '../../../hooks/use-inscription-state.hook';

export function useSirenMessages() {
  const t = useTextes('Inscription', 'RenseignementSiren');
  const { getConfigValue } = useAppConfig();
  const { organisme } = useInscriptionState();

  return {
    getInfoMessage: () => {
      return (organisme?.diffusible)
        ? `SIREN associé à l'organisme : ${organisme.raisonSociale}`
        : t['SIREN_MES4'];
    },
    getBlockingMessage: () => {
      // si le dernier organisme est sur une campagne archivée, il n'y a pas de blockage
      if (organisme?.campagne?.statut === CampagneStatut.ARCHIVEE) {
        return null;
      }
      switch (organisme?.statut) {
        case OrganismeStatutType.ATTENTE_HABILITATION:
        case OrganismeStatutType.CREATION: {
          return t['SIREN_MES5_CREATION'];
        }
        case OrganismeStatutType.MAJ_DOCUMENTS:
        case OrganismeStatutType.MAJ_ANNUELLE: {
          return t['SIREN_MES5_MAJ_ANNUELLE'];
        }
        case OrganismeStatutType.DEVALIDE: {
          return 'Cet organisme est dévalidé et ne peut donc pas procéder à une nouvelle inscription.';
        }
        case OrganismeStatutType.VALIDE: {
          const parcoursOfaUrl = getConfigValue('PARCOURS_OFA_URL');
          return <span>{t['SIREN_MES6']} {<a target="_blank" href={parcoursOfaUrl}>{parcoursOfaUrl}</a>}</span>;
        }
        default: {
          return null;
        }
      }
    },
  };
}